<template>
    <div class="col-xl-3 col-md-12 col-12">
        <div class="card">
            <div class="card-body d-flex">
                <div class="card-body align-items-center flex-column d-flex justify-content-center">
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="80" height="80" rx="40" fill="#FCEAEB"/>
                        <path d="M56.129 28.7095H23.8709C21.1986 28.7095 19.0322 30.8758 19.0322 33.5482V52.903C19.0322 55.5754 21.1986 57.7417 23.8709 57.7417H56.129C58.8013 57.7417 60.9677 55.5754 60.9677 52.903V33.5482C60.9677 30.8758 58.8013 28.7095 56.129 28.7095Z" stroke="#EA5455" stroke-width="1.93548" stroke-linejoin="round"/>
                        <path d="M55.6613 28.7094V25.6852C55.661 24.9435 55.4971 24.2109 55.1811 23.5399C54.8652 22.8688 54.405 22.2757 53.8335 21.803C53.2619 21.3302 52.5931 20.9894 51.8747 20.8049C51.1563 20.6204 50.406 20.5967 49.6774 20.7356L23.129 25.2668C21.9761 25.4865 20.936 26.1017 20.1881 27.0062C19.4402 27.9107 19.0314 29.0478 19.0322 30.2215V35.161" stroke="#EA5455" stroke-width="1.93548" stroke-linejoin="round"/>
                        <path d="M51.2903 46.4514C50.6523 46.4514 50.0286 46.2622 49.4981 45.9077C48.9676 45.5533 48.5542 45.0495 48.31 44.46C48.0659 43.8706 48.002 43.222 48.1264 42.5962C48.2509 41.9705 48.5581 41.3957 49.0093 40.9446C49.4604 40.4934 50.0352 40.1862 50.6609 40.0617C51.2867 39.9373 51.9353 40.0012 52.5247 40.2453C53.1142 40.4895 53.618 40.9029 53.9724 41.4334C54.3269 41.9639 54.5161 42.5876 54.5161 43.2256C54.5161 44.0811 54.1762 44.9016 53.5712 45.5066C52.9663 46.1115 52.1458 46.4514 51.2903 46.4514Z" fill="#EA5455"/>
                    </svg>
                    <h4 class="mt-1" style="font-size:15px">{{ $format(paiement) }} Fcfa</h4>
                    <span style="font-size:12px">Paiements effectués</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "payments",
        props:{
            paiement:{
                type: String,
                default: () => ''
            }
        }
    }
</script>

<style scoped>

</style>
